import {
	createFileRoute,
	Navigate,
	useNavigate,
	useSearch,
} from "@tanstack/react-router";
import { Button, Result } from "antd";

export const Route = createFileRoute("/")({ component: Home });

function Home() {
	// Loosely typed (not this route's own validateSearch) so it doesn't narrow "/"'s search
	// type — plenty of other routes build `to: "..." as "/"` links/navigates with their own
	// unrelated search shapes, and those would stop typechecking against a stricter schema here.
	// Set by the GitHub install callback (git-provider-connection-callback-controller.cs) when it
	// can't resolve which workspace the connection attempt belonged to (expired/invalid state,
	// workspace deleted mid-flow, etc.) — it has nowhere to send the user back to but here.
	const { git_connection } = useSearch({
		strict: false,
	}) as { git_connection?: string };
	const navigate = useNavigate();

	if (git_connection === "error") {
		return (
			<Result
				status="error"
				title="GitHub connection failed"
				subTitle="We couldn't complete the GitHub connection. The request may have expired, or the workspace it was started from is no longer available. Please try connecting again from the workspace's Integrations settings."
				extra={
					<Button type="primary" onClick={() => navigate({ to: "/login" })}>
						Continue
					</Button>
				}
				style={{ marginTop: 80 }}
			/>
		);
	}

	return <Navigate to="/login" replace />;
}
